/**
 * Reseller-admin earnings tab — eager half (CLA-910).
 *
 * Eagerly registers the file route so TanStack can match
 * `/clawinstall/admin/resellers/$customerId/earnings`; the admin gate is
 * re-applied by the parent `admin_/resellers` layout route. The component and
 * all atom / RPC / design imports are deferred to `earnings.lazy.tsx` so they
 * never land in the always-loaded `main` chunk (bundle budgets).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/admin_/resellers/$customerId/earnings")({});
